import { cloneDeep } from "lodash";
import initialState from "../../../store/initialState";
import {
    ADD_STADD_FILE_STARTING,
    ADD_STAAD_FILE_SUCCESS,
    ADD_STAAD_FILE_ERROR,
} from '../../../constants/actionTypes';

export default function addStaadFileReducer(state = initialState.addStaadFile, action) {
    switch (action.type) {
        case ADD_STADD_FILE_STARTING: {
            const newState = cloneDeep(state);
            newState.saving = true;
            newState.saved = false;
            return newState;
        }

        case ADD_STAAD_FILE_SUCCESS: {
            const { data } = action;

            const newState = cloneDeep(state);
            newState.saving = false;
            newState.saved = true;
            newState.error = null;

            newState.newMobileTower = data.mobileTower;
            return newState;
        }

        case ADD_STAAD_FILE_ERROR: {
            const newState = cloneDeep(state);
            newState.saving = false;
            newState.saved = false;
            newState.error = action.err;
            return newState;
        }

        default: {
            return state;
        }
    }
}